import { render, staticRenderFns } from "./HeaderInfo.vue?vue&type=template&id=99b783b0&scoped=true"
import script from "./HeaderInfo.vue?vue&type=script&lang=js"
export * from "./HeaderInfo.vue?vue&type=script&lang=js"
import style0 from "./HeaderInfo.vue?vue&type=style&index=0&id=99b783b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b783b0",
  null
  
)

export default component.exports